import { render, staticRenderFns } from "./seguro-para-automovel.vue?vue&type=template&id=aafacab4&"
import script from "./seguro-para-automovel.vue?vue&type=script&lang=js&"
export * from "./seguro-para-automovel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports